import { FormattedMessage } from 'react-intl'

import { Button } from '@gto/ui/button'
import { Typography } from '@gto/ui/typography'

export type PasswordChangeSuccessProps = {
  onClose: () => void
}

export const PasswordChangeSuccess = ({ onClose }: PasswordChangeSuccessProps) => {
  return (
    <div className="flex max-w-[550px] flex-col gap-8">
      <Typography
        component="h1"
        variant="h4"
      >
        <FormattedMessage id="user.settings.password.success.title" />
      </Typography>

      <Typography
        color="text.secondary"
        variant="body1"
      >
        <FormattedMessage id="user.settings.password.success.description" />
      </Typography>

      <div className="flex flex-wrap gap-4">
        <Button
          className="min-w-[200px]"
          color="primary"
          size="large"
          variant="contained"
          onClick={() => {
            window.location.href = '/app/rewards'
          }}
        >
          <FormattedMessage id="user.settings.email.validation.success.exploreDeals" />
        </Button>
        <Button
          className="min-w-[200px]"
          color="secondary"
          size="large"
          variant="contained"
          onClick={onClose}
        >
          <FormattedMessage id="user.settings.accountManagement" />
        </Button>
      </div>
    </div>
  )
}
